import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const ChatContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  maxWidth: theme.breakpoints.values.md,
  margin: '0 auto',
  flex: 1,
  minHeight: 0,
}));
